"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function MyMissionForTheVoiceless() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="221938" id="the-sonic-identity" className="bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          <div ref={imageRef as any} className={`transition-all duration-1000 delay-500 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <Card className="bg-white/5 border-none overflow-hidden p-0">
              <img src="https://iammileshen.com/wp-content/uploads/2026/05/6910EB71-F520-4570-B1C0-61B95A7493E4.jpg" alt="Miles Henshaw Portrait" className="w-full h-auto object-cover grayscale hover:grayscale-0 transition-all duration-700" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642088/img/miles_henshaw_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642088/img/miles_henshaw_portrait.png-wvc-sizes" loading="lazy" />
            </Card>
          </div>

          <div ref={textRef as any} className={`flex flex-col justify-center space-y-8 transition-all duration-1000 delay-300 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-4">
              <h2 className="text-sm md:text-base font-mono text-primary tracking-[0.2em] uppercase">
                Philosophy
              </h2>
              <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default tracking-tighter text-foreground leading-tight uppercase">
                The Sonic Identity
              </h3>
            </div>

            <div className="space-y-6">
              <p className="text-xl md:text-2xl text-foreground/90 font-sans leading-relaxed first-letter:text-7xl first-letter:font-default first-letter:text-primary first-letter:mr-3 first-letter:float-left first-letter:leading-[0.85] first-letter:mt-2">
                Capturing the raw energy of a performance requires more than just
                technical precision; it demands an understanding of the artist's
                vision. My approach to production is centred on experimental
                authenticity; it's about finding the unique friction that makes a
                record feel alive and unpolished yet professional.
              </p>

              <p className="text-lg md:text-xl text-muted-foreground font-sans leading-relaxed">
                Whether in the studio or capturing live sound, the goal is always
                to refine the sound without stripping away its soul. We embrace
                the imperfections and the grit, ensuring every track resonates
                with the same intensity that was felt in the room.&nbsp;
              </p>
            </div>

            <div className="pt-8 mt-4 border-t border-border/20 flex flex-col items-start">
              <span className="font-default text-4xl md:text-5xl text-foreground tracking-tighter transform -rotate-1 italic">
                Miles Henshaw
              </span>
              <span className="text-xs text-muted-foreground uppercase tracking-[0.3em] mt-3 font-mono">
                Producer & Mix Engineer
              </span>
            </div>
          </div>

        </div>
      </div>
    </section>;
}